import * as stylex from '@stylexjs/stylex';
import { useQuery } from '@apollo/client/react';
import { useParams } from 'react-router';
import { MdOpenInNew } from 'react-icons/md';
import { AppFab, AppButton, useOpenApp } from '~components/AppCta';
import { shared } from '~styles';
import { styles } from './styles';
import { PUBLIC_SPOT } from './query';
import { Carousel } from './components/Carousel';
import { Details } from './components/Details';
import { Hours } from './components/Hours';
import { Tribys } from './components/Tribys';
import { Stub } from './components/Stub';
export function Spot() {
  const {
    linkId = ''
  } = useParams();
  useOpenApp(`spots/${linkId}`);
  const {
    data,
    loading,
    error
  } = useQuery(PUBLIC_SPOT, {
    variables: {
      id: linkId
    }
  });
  if (loading) {
    return <main {...stylex.props(styles.container)}>
        <p {...stylex.props(shared.muted)}>Loading…</p>
      </main>;
  }
  const spot = data?.publicSpot;
  if (error || !spot) return <Stub linkId={linkId} />;
  return <main {...stylex.props(styles.container)}>
      {spot.images.length > 0 && <div {...stylex.props(styles.col1)}>
          <Carousel images={spot.images} />
        </div>}

      <h1 {...stylex.props(styles.col1, styles.title)}>{spot.name ?? 'Spot'}</h1>

      {spot.description && <p {...stylex.props(styles.col1, styles.description)}>{spot.description}</p>}

      <aside {...stylex.props(styles.side)}>
        <Details spot={spot} />
        {spot.type === 'BUSINESS' && spot.business && <Hours hours={spot.business.hours} />}
        <AppButton path={`spots/${spot.linkId}`} label="Open in the app" icon={<MdOpenInNew size={20} />} desktopOnly />
      </aside>

      {spot.groups.length > 0 && <div {...stylex.props(styles.col1)}>
          <Tribys groups={spot.groups} />
        </div>}

      <AppFab path={`spots/${spot.linkId}`} label="Open in Tribys" icon={<MdOpenInNew size={22} />} rounded="lg" />
    </main>;
}